import { Linking, Platform } from 'react-native';

// Keep public documents outside the native router. Desktop uses the default
// browser; mobile keeps its browser sheet to avoid re-entering universal links.
export function openPublicPage(path, router) {
  if (Platform.OS === 'web') return router.push(path);
  if (Platform.OS !== 'ios' && Platform.OS !== 'android') return Linking.openURL(`https://gab.ai${path}`);
  // Windows has no ExpoWebBrowser module; do not evaluate it on desktop.
  const WebBrowser = require('expo-web-browser');
  return WebBrowser.openBrowserAsync(`https://gab.ai${path}`, {
    presentationStyle: WebBrowser.WebBrowserPresentationStyle.FULL_SCREEN,
    dismissButtonStyle: 'done',
  });
}

// These route families intentionally have redirect-only native screens.
// Keep application routes and native legal documents in the app.
export function nativePublicPagePath(href) {
  if (typeof href !== 'string') return null;
  const path = href.replace(/^https:\/\/gab\.ai(?=\/)/, '');
  const pathname = path.split(/[?#]/, 1)[0];
  return /^\/(docs|learn|blog|use-cases)(\/|$)/.test(pathname)
    || /^\/(about|contact|feedback|pricing|api|llms|based-benchmark|guidelines|switch|changelog|brand|enterprise|ccpa|dmca)\/?$/.test(pathname)
    || pathname === '/sites/report' ? path : null;
}
